export function verifyPartnerTax(
  items: Array<{ id: string; squareId: string; tax: number | null }>
): boolean {
  if (!items || items.length === 0) {
    return false;
  }

  return items.some(
    (item) => item.tax !== null && item.tax !== undefined && item.tax > 0
  );
}
